import {Controller, useFormContext} from "react-hook-form";

import {IMaxValueInputProps, MaxValueField as MaxValueFieldDs} from "@pg-design/inputs-module";

export function MaxValueFieldControlled(props: Omit<IMaxValueInputProps, "value" | "onChange">) {
    const {name, ...fieldProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            render={({field: {value, ref, onChange, onBlur, disabled}, fieldState}) => (
                <MaxValueFieldDs
                    ref={ref}
                    value={value}
                    onChange={(newValue) => {
                        onChange(newValue);
                    }}
                    onBlur={onBlur}
                    error={fieldState.error?.message}
                    name={name}
                    {...fieldProps}
                    disabled={fieldProps.disabled || disabled}
                />
            )}
            name={name}
        />
    );
}
import {Controller, useFormContext} from "react-hook-form";

import {IMaxValueInputProps, MaxValueField as MaxValueFieldDs} from "@pg-design/inputs-module";

export function MaxValueFieldControlled(props: Omit<IMaxValueInputProps, "value" | "onChange">) {
    const {name, ...fieldProps} = props;
    const {control} = useFormContext();

    return (
        <Controller
            control={control}
            render={({field: {value, ref, onChange, onBlur, disabled}, fieldState}) => (
                <MaxValueFieldDs
                    ref={ref}
                    value={value}
                    onChange={(newValue) => {
                        onChange(newValue);
                    }}
                    onBlur={onBlur}
                    error={fieldState.error?.message}
                    name={name}
                    {...fieldProps}
                    disabled={fieldProps.disabled || disabled}
                />
            )}
            name={name}
        />
    );
}
